'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
export const defaultAreaSeriesOptions = fromJS({
  fillOpacity: 0.3,
  marker: {
    symbol: 'circle',
    lineColor: null,
    lineWidth: 2,
    radius: 3.5,
    fillColor: colors.MARKER_FILL_COLOR
  },
  trackByArea: true
});